import { render, staticRenderFns } from "./RedirectForm.vue?vue&type=template&id=58bd1c26&"
import script from "./RedirectForm.vue?vue&type=script&lang=js&"
export * from "./RedirectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports